import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"

const Basic = (props: {rowData: [], defaults: object, field: string, namedItems: object, persist: Function}) => {
  const emptyRecord = {
    type: null,
    value: null,
    inflationNamedItemId: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field] || {...emptyRecord});

  function updateData(val:any, field:string|null):void {
    let nextData = _.cloneDeep(data)
    field ? nextData[field] = val : nextData = val
    setData(nextData);
    nextData ? props.persist({...nextData}, 'capdetail', props.rowData) : props.persist(null, 'capdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('lineitem', 'capdetail')(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon persist={() => updateData(null, null)}/>
      <SingleRowCarouselState_s>
        <div>
          <label>Type</label>
          <DropdownInput
            className="automated"
            data={data}
            attrs={attrs}
            field="type"
            options={['Amt']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Monthly Amt</label>
          <NumberInput
            className="automated"
            data={data}
            attrs={attrs}
            field="value"
            readPrecision={2}
            writePrecision={2}
            persist={updateData}
            disabled={!data}
          />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput
            className="automated"
            data={data}
            attrs={attrs}
            field="inflationNamedItemId"
            options={props.namedItems['inflation']}
            persist={updateData}
            disabled={!data}
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Basic
